import type { Patient, Reference } from '@medplum/fhirtypes'
import { Participant } from '@seen/core/models/patients/participant'
import { cn } from '@seen/ui'
import { IconCheck } from '@tabler/icons-react'
import { format, parseISO } from 'date-fns'
import type { JSX } from 'react'
import { Avatar } from '#src/components/core/Avatar/Avatar.tsx'
import { PatientName } from '#src/components/patient/PatientName.tsx'
import { useRead } from '#src/hooks/useRead.ts'

export function ParticipantOption({
  participant,
  isSelected,
}: {
  participant: Reference<Patient>
  isSelected?: boolean
}): JSX.Element {
  const { data: instance } = useRead(Participant, participant)
  return (
    <div className="flex flex-1 items-center justify-between">
      <div className="flex items-center gap-2">
        <Avatar profile={participant} size="icon" />
        <p>
          {instance && <PatientName participant={instance} />}
          {instance?.birthDate && (
            <span className="text-foreground-secondary">
              {' '}
              {format(parseISO(instance.birthDate), 'M/d/yy')}
            </span>
          )}
        </p>
      </div>
      <IconCheck
        className={cn(
          'mr-0.5 size-4 shrink-0 opacity-0',
          isSelected && 'opacity-100'
        )}
      />
    </div>
  )
}
